declare global {
  interface Window {
    fbq: any;
    _fbqInitialized?: boolean;
  }
}

const useEventTracking = () => {
  const trackCustomEvent = (eventName: string, parameters = {}) => {
    // Function to attempt tracking
    const attemptTracking = () => {
      if (typeof window.fbq === 'function' && window._fbqInitialized) {
        // Map custom events to Facebook standard events where possible
        const fbEventName = eventName;

        // Format parameters for Facebook
        const fbParameters = {
          ...parameters,
          event_source_url: window.location.href,
          custom_event_name: eventName // Keep original name as custom parameter
        };

        window.fbq('track', fbEventName, fbParameters);

        return true;
      }
      return false;
    };

    // Try immediately first
    if (attemptTracking()) {
      return;
    }

    // If not available, wait for it to load
    let attempts = 0;
    const maxAttempts = 5; // Reduced attempts since pixel should be ready

    const checkAndTrack = () => {
      attempts++;

      if (attemptTracking()) {
        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(checkAndTrack, 1000); // Wait longer between attempts
      }
    };

    checkAndTrack();
  };

  return { trackCustomEvent };
};

export default useEventTracking;
